export const DOMAIN_SET_ACTIVE = "DOMAIN_SET_ACTIVE";

/* --------------------- DOMAIN COLLECTION LIST HANDLERS -------------------- */
export const DOMAIN_COLLECTION_LIST_CLEAR = "DOMAIN_COLLECTION_LIST_CLEAR";
export const DOMAIN_COLLECTION_LIST_CLEAR_BY_TLD = "DOMAIN_COLLECTION_LIST_CLEAR_BY_TLD";
export const DOMAIN_COLLECTION_LIST_CREATE = "DOMAIN_COLLECTION_LIST_CREATE";
export const DOMAIN_COLLECTION_LIST_UPDATE = "DOMAIN_COLLECTION_LIST_UPDATE";
export const DOMAIN_COLLECTION_LIST_DELETE = "DOMAIN_COLLECTION_LIST_DELETE";

/* -------------------------- DOMAIN LIST HANDLERS -------------------------- */
export const DOMAIN_LIST_ADD = "DOMAIN_LIST_ADD";
export const DOMAIN_LIST_ADD_ASYNC = "DOMAIN_LIST_ADD_ASYNC";
export const DOMAIN_LIST_CLEAR = "DOMAIN_LIST_CLEAR";
export const DOMAIN_LIST_DELETE = "DOMAIN_LIST_DELETE";
export const DOMAIN_LIST_LOADING = "DOMAIN_LIST_LOADING";

/* ------------------------ DOMAIN REGISTER RELATION ------------------------ */
export const DOMAIN_RELATION_SET = "RELATION_SET";
export const DOMAIN_RELATION_DETAILS_SET = "DOMAIN_RELATION_DETAILS_SET";

/* ----------------------- DOMAIN REGISTER DNS RECORDS ---------------------- */
export const DOMAIN_DNS_RECORD_LIST_CREATE = "DOMAIN_DNS_RECORD_LIST_CREATE";
export const DOMAIN_DNS_RECORD_LIST_UPDATE = "DOMAIN_DNS_RECORD_LIST_UPDATE";

/* ------------------------ DOMAIN TLD LIST HANDLERS ------------------------ */
export const DOMAIN_TLD_LIST_ADD = "DOMAIN_TLD_LIST_ADD";
export const DOMAIN_TLD_LIST_ADD_ALL = "DOMAIN_TLD_LIST_ADD_ALL";
export const DOMAIN_TLD_LIST_CLEAR = "DOMAIN_TLD_LIST_CLEAR";
export const DOMAIN_TLD_LIST_DELETE = "DOMAIN_TLD_LIST_DELETE";

/* ----------------------- DOMAIN CONFIRMATION HANDLER ---------------------- */
export const DOMAIN_CONFIRMATION_CREATE = "DOMAIN_CONFIRMATION_CREATE";

/* -------------------------- DOMAIN RESET HANDLER -------------------------- */
export const DOMAIN_RESET_ALL = "DOMAIN_RESET_ALL";
